module.exports = __webpack_public_path__ + "img/632f1eba4a0d2f59fb685843_2-p-500.cabd2b53.png";